module.exports = __webpack_public_path__ + "img/Spiegelbilder.04bd77a0.svg";